import { render, staticRenderFns } from "./Moderator.vue?vue&type=template&id=0e04cc3c&"
import script from "./Moderator.vue?vue&type=script&lang=js&"
export * from "./Moderator.vue?vue&type=script&lang=js&"
import style0 from "./Moderator.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports